<template>
  <div class="center-container">
    <div class="center-content">
      <div class="placeholder-icon">
        <svg v-if="large" width="64px" height="64px" viewBox="0 0 28 28"><use :xlink:href="iconPath"></use></svg>
        <svg v-else width="44px" height="44px" viewBox="0 0 16 16"><use :xlink:href="iconPath"></use></svg>
      </div>
      <h2 class="bold">{{title}}</h2>
      <p v-if="message && !isHtml">{{message}}</p>
      <p v-if="message && isHtml" v-html="message">{{message}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheEmptyList',
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: false,
      default: () => {
        return ''
      }
    },
    large: {
      type: Boolean,
      required: false,
      default: () => {
        return true
      }
    },
    icon: {
      type: String,
      required: false,
      default: () => {
        return 'button-glyph-comment'
      }
    },
    isHtml: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      }
    }
  },
  computed: {
    iconPath: function () {
      return '/static/sprites.svg#' + this.icon
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TheEmptyList.vue